import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 13, viewBox: "0 0 12 13", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.30002 7.1999V12.0999H6.70002V7.1999H11.6V5.7999H6.70002V0.899902H5.30002V5.7999H0.400024V7.1999H5.30002Z" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
